import script from "./QuizStatsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizStatsPage.vue?vue&type=script&setup=true&lang=js"

import "./QuizStatsPage.vue?vue&type=style&index=0&id=b4c56c6c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4c56c6c"]])

export default __exports__